import React from "react";
import { FaWhatsapp } from "react-icons/fa";
import "./ProjectCommunicationLinks.css";

const ProjectCommunicationLinks = ({ project, compact = false }) => {
  const links = [
    { label: "Join WhatsApp group", url: project?.communicationLinks?.whatsappGroup },
    { label: "Follow WhatsApp channel", url: project?.communicationLinks?.whatsappChannel },
  ].filter((item) => item.url);

  if (!links.length) return null;

  return (
    <section className={`project-communication-links${compact ? " project-communication-links--compact" : ""}`} aria-label="Project WhatsApp links">
      {!compact && (
        <div>
          <h3>Stay connected</h3>
          <p>Use the official project links for updates and volunteer coordination.</p>
        </div>
      )}
      <div className="project-communication-links__actions">
        {links.map((link) => (
          <a key={link.label} href={link.url} target="_blank" rel="noopener noreferrer">
            <FaWhatsapp aria-hidden="true" />
            {link.label}
          </a>
        ))}
      </div>
    </section>
  );
};

export default ProjectCommunicationLinks;
